export default {
  ALL: 'All',
  PENDING_DEMAND: 'Gathering Demand',
  PENDING_PLANNING: 'Pending Planning',
  PENDING_OPTIMIZATION_RESULT: 'Pending Planning',
  PENDING_RECURRING_OPTIMIZATION: 'Pending Planning',
  PENDING_SECOND_CUTOFF: 'Pending Second Cutoff',
  ACTIVE: 'Active',
  INCOMPLETE: 'Incomplete',
  PENDING_ASSIGNMENT: 'Pending Assignment',
  CANCELLED: 'Cancelled',
  ARCHIVED: 'Archived',
  archive: 'Archive',
  locations: {
    CAMPUS: 'Office',
    POI: 'POI',
    PERSONNEL_SHUTTLE_STOP: 'Stops',
    PERSONNEL_HOME_ADDRESS: 'Rider Home Addresses',
    PERSONNEL_WORK_LOCATION: 'Rider Work Location',
  },
  header: 'Route Groups',
  createWorkgroup: 'New Route Group',
  timeOfArrival: 'Arrival Time at',
  departureTime: 'Departure Time',
  arrivalTime: 'Arrival Time',
  readyToDeparture: 'Ready for Departure',
  period: 'Period',
  periodicallyUpdatedGroup: 'Periodically Updated Group',
  periodicallyUpdatedGroupInfo:
    'Periodically updated groups collect demands from attendees for each period and the shuttle lines are re-planned accordingly.',
  selectPeriod: 'Select Period',
  roundTrip: 'Round Trip',
  oneWay: 'One Way',
  doubleDirection: 'Round Trip',
  fromWhere: 'From',
  toWhere: 'To',
  openSelectMenu: 'Select...',
  groupName: 'Group Name',
  enterDescription: 'You can enter a description',
  giveNameToGroup: 'Give a name to this group',
  selectLocation: 'Select a location',
  selectDeparturePoint: 'Select departure point for first trip',
  responsibleCampus: 'Responsible Campus',
  openToDemand: 'Open for Opt-In',
  riderQuota: 'Rider Quota',
  wheelchairQuota: 'Wheelchair Quota',
  wheelchairQuotaRequired: 'Wheelchair quota value is required when wheelchair quota limit is enabled.',
  departmentRequest: 'Department(s) that can request',
  reportPlanningEnd: 'Report Planning End',
  startOfBookbuilding: 'Start of Opt-In Period',
  endOfBookbuilding: 'End of Opt-In Period',
  waitlistOptinDeadline: 'Waitlist Opt-in deadline',
  definition: 'Definition',
  location: 'Locations',
  timing: 'Timing',
  operationTimes: 'Operation Times',
  changeRouteOrStop: 'Change Route or Stop',
  removeFromGroup: 'Remove from Group',
  routePlanning: 'Route planning has a deadline',
  picnic: 'Picnic',
  overwork: 'Overwork',
  saturdayShift: 'Saturday Shift',
  customAddress: 'Custom Address',
  personnelLocations: 'Rider Locations',
  PERSONNEL_SHUTTLE_STOP: 'Stops',
  PERSONNEL_HOME_ADDRESS: 'Rider Home Adresses',
  PERSONNEL_WORK_LOCATION: 'Rider Work Locations',
  createRecurringGroups: 'Time when the group will be visible to riders',
  beforeStart: 'before start day.',
  makeDefault: 'Make Default',
  default: 'Default',
  searchGroup: 'Search Group',
  selectedPerson: 'person selected',
  archiveSearchGroup: 'Search archive groups...',
  deleteSelected: 'Delete Selected',
  sortBy: 'Sort By',
  sortByEndDate: 'Sort by end date',
  sortByStartDate: 'Sort by start date',
  sortByEmployeesCount: 'Sort by number of employees',
  indefinite: 'Indefinite',
  showMore: 'Show More',
  campus: 'Campus',
  selectEndDate: 'Select End Date',
  hoursBeforeTrip: '{hours} hours before the first trip',
  hoursBeforeFirstTrip: 'Planning ends {hours} hours before first trip.',
  changeStatus: 'Change Status',
  statusChanged: 'Status changed as {0}',
  invalidDepartureTime: 'Invalid Departure Time',
  invalidArrivalTime: 'Invalid Arrival Time',
  addNewCustomAddress: 'Add New Custom Address',
  descriptor: 'Descriptor',
  createdBy: 'Created by',
  makeDefaultRouteGroup: 'Make default route group for newly added staff.',
  paidRoutes: 'Paid Routes',
  organizationBoardingFare: 'Organization Boarding Fare',
  guestBoardingFare: 'Guest Boarding Fare',
  monthlyPassApplied: 'Free with Monthly Pass',
  boardingFare: 'Boarding Fare',
  riderPercent: 'Rider',
  organizationPercent: 'Organization',
  feeFieldsRequired: 'These fields cannot be left blank: {fields}',
  percentValuesMustBeBetween0And100: 'Rider and organization percentages must be between 0-100.',
  totalPercentCannotExceed100: 'The sum of Rider and Organization percentages cannot exceed 100%',
  makeDefaultEmployees: 'Make default for newly added employees.',
  personnelLabeledVanpoolOnly: 'Only employees with vanpool tag.',
  automation: 'Automation',
  optimization: 'Optimization',
  vehicleAssignment: 'Vehicle Assignment',
  assignDriverVehicleAutomatically: 'Assign driver and vehicle automatically by the system',
  assignManually: 'Assign manually',
  assignmentsFor: 'Assignments for {regionName}',
  addDriverAndVehicle: '+ Add Driver and Vehicle',
  activation: 'Activation',
  initiateAutomation: 'Initiate Automation',
  automationConfirm: {
    initiateTitle: 'Initiate Automation?',
    initiateMessage:
      'The automation flow will run for this route group using the current rider list. Routes will be generated and, based on your automation settings, drivers and vehicles will be assigned and the routes will be activated automatically. Do you want to continue?',
    runButton: 'Run Automation',
    rerunTitle: 'Re-run Automation?',
    rerunMessage:
      'Routes have already been generated for this route group. If you continue:<br><br>(1) All not-started trips of the existing routes will be cancelled.<br>(2) Routes will be re-generated based on the current rider list.<br>(3) Any manual changes made to the existing routes will be lost.<br>(4) Trips that are in progress or already completed will not be affected; the new routes will take effect starting from the next trips.<br><br>Do you want to continue?',
    rerunButton: 'Re-run Automation',
  },
  deleteGroupInstanceConfirm: "Are you sure you'd like to delete this group instance?",
  startsFromtheDepot: 'Starts from the depot',
  startingDepot: 'Starting Depot',
  selectDepot: 'Select a depot',
  endingDepot: 'Ending Depot',
  endsintheDepot: 'Ends in the depot',
  headwayBasedOtpTracking: 'Headway based OTP tracking',
  definedRegion: 'Defined region(s)',
  coverageArea: 'Coverage Area',
  noRestrictions: 'No restrictions',
  addCampus: 'Add Campus',
  multiCampus: 'Multi-Campus',
  selectRegion: 'Select a region',
  selectADeparturePoint: 'Select a departure point',
  enterThereadyToDepartureDepartureTimes:
    'Enter the desired "ready for departure" & "departure" times from first campus',
  enterArrivalTimeToLastDestination: 'Enter the desired arrival time to last destination',
  serviceTimeForEachStop: 'Service time for each stop',
  maxTripDuration: 'Maximum trip duration',
  maxTripDurationHint:
    'Longest time a vehicle may spend on a trip planned by the optimizer. Left empty, 180 minutes is used.',
  calculate: 'Calculate',
  vehicleTrackingStart: 'Vehicle Start Time',
  dynamic: 'Dynamic',
  regular: 'Regular',
  fixed: 'Fixed',
  DYNAMIC: 'Dynamic',
  REGULAR: 'Regular',
  FIXED: 'Fixed',
  readyForDepartureMustEarlierDepartureTime: 'Ready for departure time must be earlier than departure time.',
  acceptsReservations: 'Accepts Reservations',
  waitlistEnabled: 'Enable waitlist after first cut-off',
  demandEndMustBeGreaterThanSecondCutOff: 'End of Opt-In Period must be greater than waitlist opt-in deadline.',
  waitlistSecondCutOffRequired: 'Waitlist Opt-in deadline must be filled when waitlist is enabled.',
  demandEndRequired: 'End of Opt-In Period must be filled when waitlist opt-in deadline is set.',
  noReservations: 'No Reservations',
  ring: 'Ring',
  schedule: 'Schedule',
  startingEndingPoint: 'Starting/Ending Point',
  stops: 'Stops',
  workdays: 'Workdays (Mon-Fri)',
  singleTrip: 'Single Trip',
  multipleTrips: 'Multiple Trips',
  periodical: 'Periodical',
  atSpecificHours: 'At Specific Hours',
  departureTimeFromFirstPoint: 'Enter the desired departure time from the first point',
  tripsOnEvery: 'Trips on every',
  numberOfTrips: 'Number of Trips',
  min: 'min(s)',
  hour: 'hour(s)',
  totalDurationhours: 'The total duration of the trips exceeds 24 hours.',
  departureTimeCampusName: 'Departure Time from <b>{0}',
  calculateAccordingly: 'Calculate for all accordingly',
  addTrip: 'Add Trip',
  considerTimeBasedTrafficData: 'Consider time-based traffic data.',
  calculateForAll: 'Calculate for all',
  viewEditTimesOtherTrips: 'View & Edit Times for Other Trips',
  hideTimesOtherTrips: 'Hide Times for Other Trips',
  typeNameStop: 'Type a name for the stop',
  use: 'Use',
  addStop: 'Add Stop',
  deleteThisRouteGroup:
    'Deleting this route group will remove all upcoming instances. This action cannot be undone. Are you sure?',
  updateEndDateWarning:
    'Any instances that have not yet started after the new end date will be removed. If you extend the end date, instances for those dates will be recreated.',
  acceptReservations: 'Accept Reservations',
  theSameDay: 'The same day',
  daysBeforeTripDate: 'day(s) before the trip date',
  singleSelectedMulticampusMessage:
    'You have selected a single campus for a multi-campus trip. Do you want to add more campuses?',
  reservationsCanBeMadeUntilCutOffTime: 'Reservations can be made until a cut-off time.',
  closeFilters: 'Close Filters',
  type: 'Type',
  creator: 'Creator',
  reservations: 'Reservations',
  required: 'Required',
  notRequired: 'Not Required',
  campusCommuteOptions: 'Show campus times as commute options during rider registration.',
  validationErrors: 'Validation Errors',
  startDateRequired: 'Start date is required',
  departureTimeError: 'Departure time has errors',
  arrivalTimeError: 'Arrival time has errors',
  endDateRequired: 'End date is required when end date option is selected',
  periodRequired: 'Period selection is required for periodically updated groups',
  readyTimeMustBeBeforeDeparture: 'Ready for departure time must be before departure time',
  allDepartureTimesRequired: 'All departure times must be filled for each campus location',
  allTimesRequiredForRoundTrip: 'All departure times and return arrival time are required for round trip',
  allTimesRequiredForRoundTripMulti:
    'All departure times, return arrival times are required for round trip with multiple campuses',
  arrivalTimeRequired: 'Arrival time is required',
  returnTimesRequired: 'Return departure and ready times are required for round trip',
  allArrivalTimesRequired: 'All arrival times must be filled for each campus location',
  allReturnTimesRequired: 'All return times must be filled for round trip with multiple campuses',
  // New cutoff time translations
  unitHours: 'hour(s)',
  beforeTripAt: 'before the trip at',
  until: 'Until',
  startAt: 'At',
  value: 'Value',
  daysBeforeTrip: 'day(s) before the trip',
  startTimeRequired: 'Time is required',
  startDaysRequired: 'Days value is required',
  endTimeRequired: 'Time is required',
  endDaysRequired: 'Days value is required',
  waitlistTimeRequired: 'Time is required',
  waitlistDaysRequired: 'Waitlist days value is required',
  valueCannotBeNegative: 'Value cannot be negative',
  validationWaitlistAfterEnd: 'Waitlist Opt-In Deadline cannot be earlier than End of Opt-In Period.',
  validationEndBeforeStart: 'End of Opt-In Period cannot be earlier than Start of Opt-In Period.',
  validationStartAfterReadyTime: 'Start of Opt-In Period cannot be later than the trip ready time.',
  validationEndAfterReadyTime: 'End of Opt-In Period cannot be later than the trip ready time.',
  validationSameDayRequired:
    'When End of Opt-In Period is set to the same day, Waitlist Opt-In Deadline must also be the same day.',
  quotaRequired: 'Quota value is required when limit is enabled.',
  person: 'person',
};
